export default api => ({
  forceBatchProcessing: () => api.post('/testing-tool/process-transactions'),
  includeInReport: (transactionId, transactionUrl) => api.post(`/testing-tool/include-in-report/${transactionId}/${transactionUrl}`)
})
